const THREE = (window.THREE = require('three'));

const rotationSpeed = 0.0005;

class SpaceStationScene extends THREE.Scene {
  spaceStation = null;
  spaceStationWire = null;

  constructor(modelLoader, spotLight, spotLight2) {
    super();

    this.update = this.update.bind(this);

    this.initSpaceStation(modelLoader, spotLight, spotLight2);
  }

  initSpaceStation = (loader, spotLight, spotLight2) => {
    /* const spaceStationWireMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1
    }); */

    /* const spaceStationWireMaterial = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      emissive: 0xf9f9f9,
      flatShading: true,
      metalness: 0.1,
      roughness: 1.1,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1,
    }); */
    const spaceStationWireMaterial = new THREE.MeshLambertMaterial({
      color: 0xffffff,
      emissive: 0xfbfbfb,
      flatShading: true,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1,
    });

    loader.load(
      `${
        process.env.PUBLIC_URL
        //}/webgl_monochrome/model/SpaceStation_Coloured.fbx`,
      }/webgl_monochrome/model/spacestation_reduced_vrs3.fbx`,
      obj => {
        const spaceStation = obj.children[0];
        spaceStation.scale.multiplyScalar(250);
        spaceStation.castShadow = true;
        spaceStation.receiveShadow = true;
        spaceStation.rotation.x = THREE.Math.degToRad(8);
        spaceStation.rotation.z = THREE.Math.degToRad(-22);

        spaceStation.position.x = -700;
        spaceStation.position.y = -675;
        spaceStation.position.z = -1100;

        spotLight.target = spotLight2.target = spaceStation;

        const spaceStationWire = new THREE.Mesh(
          spaceStation.geometry,
          spaceStationWireMaterial
        );
        const wireGeometry = new THREE.EdgesGeometry(spaceStationWire.geometry);
        const wireMaterial = new THREE.LineBasicMaterial({
          color: 0xf1f1f1,
          linewidth: 1,
          lights: false,
        });
        const wireMesh = new THREE.LineSegments(wireGeometry, wireMaterial);

        spaceStationWire.castShadow = true;
        spaceStationWire.receiveShadow = true;

        spaceStation.add(spaceStationWire);
        spaceStationWire.add(wireMesh);
        spaceStationWire.layers.set(100);
        wireMesh.layers.set(100);
        this.spaceStation = spaceStation;
        this.spaceStationWire = spaceStationWire;
        this.add(spaceStation);
      }
    );
  };

  update(deltaMultiplier) {
    if (!this.spaceStation) return;

    const axis = new THREE.Vector3(0, 1, 0);
    this.spaceStation.rotateOnAxis(axis, rotationSpeed * deltaMultiplier);
  }
}

export default SpaceStationScene;



// WEBPACK FOOTER //
// ./src/modules/parallax/webgl/SpaceStationScene.js